module.exports = __webpack_public_path__ + "static/media/ATM.b20b763f.svg";